package uk.co.nickthecoder.kyd.appearance

import uk.co.nickthecoder.glok.backend.backend
import uk.co.nickthecoder.glok.property.boilerplate.colorProperty
import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.glok.util.Matrix
import uk.co.nickthecoder.kyd.CoordinateSystem
import uk.co.nickthecoder.kyd.util.Vector2
import uk.co.nickthecoder.kyd.vector2Property

class RepeatingGraphic(val graphic: Graphic) : StretchableAppearance, TintedAppearance {

    override val tintProperty by colorProperty(Color.WHITE)
    override var tint by tintProperty

    /**
     * The positions of two opposite corners in [CoordinateSystem.local] coordinates.
     * Initially, these are determined by the [Graphic]'s data such that 1 copy of the texture will be drawn.
     */
    override val corner0Property by vector2Property(Vector2(- graphic.pin.x, graphic.pin.y))
    override var corner0 by corner0Property

    override val corner2Property by vector2Property(
        Vector2(graphic.width - graphic.pin.x, graphic.pin.y - graphic.height)
    )
    override var corner2 by corner2Property

    override val resourcePath get() = graphic.path()

    override fun draw(modelMatrix: Matrix) {
        // TODO Shouldn't be needed, but it is needed when playing in a browser.
        graphic.texture.setRepeating(true,true)
        backend.reportError()

        val s = corner2 - corner0
        backend.drawTintedTexture(
            graphic.texture,
            tint,
            0f, 0f, s.x, s.y,
            corner0.x, corner0.y, s.x, s.y,
            modelMatrix
        )
    }

}

